import { render, staticRenderFns } from "./WDateInput.vue?vue&type=template&id=4a1c7e0d&lang=pug&"
import script from "./WDateInput.vue?vue&type=script&lang=js&"
export * from "./WDateInput.vue?vue&type=script&lang=js&"
import style0 from "./WDateInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports